import React, { useState, useEffect } from 'react';
import FastEntryWatermark from "./FastEntryWatermark";
import DGIWatermark from "components/DGIWatermark";
import { constructImageUrl, getURLColor, handleImageFallback } from "utilities/imageUrlUtils";
import { buildProductUrl } from "utilities/navigation";

export const FastEntryLineItemImage = ({ src, productUrl, dgiStyleSku, color }) => {
  const [imgSrc, setImgSrc] = useState(null);

  // Generate the product URL if not provided
  const generatedProductUrl = dgiStyleSku && color ? 
    buildProductUrl(dgiStyleSku, color) : 
    productUrl;

  // Construct image URL based on style SKU and color when available
  useEffect(() => {
    if (dgiStyleSku && color) {
      // Use the utility functions to construct the image URL
      const urlColor = getURLColor({ name: color });
      const constructedUrl = constructImageUrl(dgiStyleSku, urlColor, 0);
      setImgSrc(constructedUrl);
    } else if (src) {
      // Fall back to the provided src if available
      setImgSrc(src);
    } else {
      setImgSrc(null);
    }
  }, [src, dgiStyleSku, color]);

  const onSrcError = async () => {
    // If the URL contains our CloudFront domain, try the fallback
    if (imgSrc && imgSrc.includes('d34c0c1in94n75.cloudfront.net')) {
      // Extract dgiStyle, color, and index from the URL
      const regex = /\/(\d{7,8})-(.+)-(\d+)\.[a-zA-Z]+$/;
      const matches = imgSrc.match(regex);
      
      if (matches && matches.length === 4) {
        const style = matches[1];
        const color = matches[2];
        const imgIndex = matches[3];
        
        const fallbackUrl = await handleImageFallback(style, color, imgIndex);
        if (fallbackUrl) {
          setImgSrc(fallbackUrl);
          return;
        }
      }
    }
    setImgSrc(null);
  };

  // If no image source is available
  if (!imgSrc) {
    // Use DGIWatermark if style and color are selected but image is not available
    if (dgiStyleSku && color) {
      return (
        <div style={{ 
          width: '60px', 
          height: '75px', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }}>
          <DGIWatermark />
        </div>
      );
    }
    
    // Otherwise use FastEntryWatermark with "Select a style" message
    return (
      <div style={{ 
        width: '60px', 
        height: '75px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}>
        <FastEntryWatermark size="small" />
      </div>
    );
  }

  const image = (
    <img
      src={imgSrc}
      onError={onSrcError}
      alt={null}
      style={{
        display: "block",
        maxHeight: "75px",
        maxWidth: "60px",
        height: "auto",
        width: "auto",
        objectFit: "contain",
        margin: "0 auto",
        cursor: generatedProductUrl ? "pointer" : "default",
      }}
    />
  );

  return generatedProductUrl ? (
    <a
      href={generatedProductUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ 
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "60px",
        height: "75px"
      }}
    >
      {image}
    </a>
  ) : (
    <div style={{ 
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "60px",
      height: "75px"
    }}>
      {image}
    </div>
  );
};

export default FastEntryLineItemImage;